import React from 'react';
import boltIcon from './assets/icons/speed-icon.png';
import lockIcon from './assets/icons/security-icon.png';
import shieldIcon from './assets/icons/guarantee-icon.png';

const WhyChooseUsSection = ({ isArabic }) => {
  const text = {
    en: {
      subtitle: "WHY CHOOSE US",
      title: "12 years of trusted experience",
      features: [
        {
          title: "Fast Service",
          description: "Experience lightning-fast processing and quick turnaround times for all your financial needs.",
          icon: boltIcon
        },
        {
          title: "Maximum Safety",
          description: "Your security is our priority with advanced protection measures and secure transactions.",
          icon: lockIcon
        },
        {
          title: "Guaranteed",
          description: "Enjoy our no hassle 100% satisfaction guarantee.",
          icon: shieldIcon
        }
      ]
    },
    ar: {
      subtitle: "لماذا تختارنا",
      title: "12 عامًا من الخبرة الموثوقة",
      features: [
        {
          title: "خدمة سريعة",
          description: "استمتع بمعالجة فائقة السرعة وأوقات استجابة سريعة لجميع احتياجاتك المالية.",
          icon: boltIcon
        },
        {
          title: "أقصى درجات الأمان",
          description: "أمانك هو أولويتنا مع تدابير حماية متقدمة ومعاملات آمنة.",
          icon: lockIcon
        },
        {
          title: "مضمون",
          description: "استمتع بضمان رضا 100% بدون متاعب.",
          icon: shieldIcon
        }
      ]
    }
  };

  const currentLang = isArabic ? 'ar' : 'en';

  return (
    <section className="py-12 sm:py-16 lg:py-20" style={{backgroundColor: '#E6F5F3'}}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 max-w-7xl">
        {/* Subtitle */}
        <div className="text-center mb-3 sm:mb-4">
          <p className="text-xs sm:text-sm font-semibold tracking-wider uppercase" style={{color: '#006655'}}>
            {text[currentLang].subtitle}
          </p>
        </div>

        {/* Main Title */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight">
            {text[currentLang].title}
          </h2>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {text[currentLang].features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-6 shadow-sm hover:shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className="mb-3 sm:mb-4 flex justify-center">
                <div 
                  className="w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center"
                  style={{backgroundColor: '#F0F9F7'}}
                >
                  <img 
                    src={feature.icon} 
                    alt={feature.title} 
                    className="w-20 h-20 sm:w-24 sm:h-24 object-contain"
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-bold text-black mb-2 sm:mb-3 text-center">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;

